import React, { Component,Fragment } from 'react';
import {withRouter} from 'react-router-dom';
import Header from './Header';
import Sidebar from './Sidebar';
import StyleSwitcher from './StyleSwitcher';

class Layout extends Component {
    render() {  
        return (
            <Fragment>
                <Header/>
                <Sidebar/> 
                <StyleSwitcher/>
            </Fragment>
        );
    }
}
 
export default withRouter(Layout);


// WEBPACK FOOTER //
// ./src/components/Layout/Layout.js